/* Keep badges on native links, including Shopify section replacements. */
(() => {
  'use strict';
  const key = value => String(value || '').normalize('NFKC').toLowerCase().replace(/[^a-z0-9]/g, '');
  function applyBadges(root) {
    const headers = root.matches && root.matches('[data-es-header]') ? [root] : root.querySelectorAll('[data-es-header]');
    headers.forEach(header => {
      const configured = key(header.dataset.esNewArrivalsLabel || 'New Arrivals');
      header.querySelectorAll('.nav-bar__link, .header__desktop-nav .nav-dropdown__link, .es-mobile-main-links > li > .mobile-menu__nav-link').forEach(link => {
        if (link.querySelector('.es-menu-new')) return;
        const label = link.querySelector('.es-menu-label');
        const itemKey = key((label || link).textContent);
        if (itemKey !== 'newarrivals' && itemKey !== 'newarivals' && itemKey !== configured) return;
        const badge = document.createElement('span');
        badge.className = 'es-menu-new';
        badge.textContent = 'NEW';
        if (label) {
          label.setAttribute('data-es-new-arrivals', '');
          label.append(badge);
        } else {
          const wrapper = document.createElement('span');
          wrapper.className = 'es-menu-label';
          wrapper.setAttribute('data-es-new-arrivals', '');
          Array.from(link.childNodes).filter(node => node.nodeType !== Node.ELEMENT_NODE || !node.matches('svg, .icon')).forEach(node => wrapper.append(node));
          wrapper.append(badge);
          link.prepend(wrapper);
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => applyBadges(document), { once: true });
  else applyBadges(document);
  document.addEventListener('shopify:section:load', event => applyBadges(event.target));
})();
